import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { ProgressCircle } from '@americanexpress/dls-react';
import StatusSiteLanding from './Pages/StatusSiteLanding';

import reducer from '../duck';

const StatusSite = ({ languageData, locale }) => {
  if (Object.entries(languageData).length === 0) {
    return <ProgressCircle />;
  }

  return (
    <IntlProvider locale={locale} messages={languageData}>
      <StatusSiteLanding lang={locale} />
    </IntlProvider>
  );
};

export const TestableStatusSite = StatusSite;

StatusSite.propTypes = {
  languageData: PropTypes.shape({}).isRequired, // no need to restate all the keys in the lang pack
  locale: PropTypes.string.isRequired,
};

export const loadModuleData = ({ store: { dispatch } }) =>
  dispatch(loadLanguagePack('unify-status-site', { fallbackLocale: 'en-US' }));

StatusSite.holocron = {
  name: 'unify-status-site',
  loadModuleData,
  reducer,
};

export default oneAppModuleWrapper('unify-status-site')(StatusSite);
